var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Newspaper",
  clipPath: "url(#clip0_2448_207)"
}, /*#__PURE__*/React.createElement("g", {
  id: "katman 2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14 13.3333H1.99996C1.64634 13.3333 1.3072 13.1929 1.05715 12.9428C0.807102 12.6928 0.666626 12.3536 0.666626 12V2.66666H12.6666V12C12.6666 12.3536 12.8071 12.6928 13.0571 12.9428C13.3072 13.1929 13.6463 13.3333 14 13.3333Z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M12.6666 6.66666H15.3333V12C15.3333 12.3536 15.1928 12.6928 14.9428 12.9428C14.6927 13.1929 14.3536 13.3333 14 13.3333",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M6.00004 5.33334H3.33337V8H6.00004V5.33334Z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M8.66663 5.33334H9.99996",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M8.66663 8H9.99996",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M3.33337 10.6667H10",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2448_207"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));

export default __webpack_public_path__ + "static/media/Newspaper.e40d1e48.svg";
export { SvgComponent as ReactComponent };